import type { AiToneAndVoiceSettings } from "@redotech/redo-concierge-settings-common/ai-tone-and-voice";
import { RedoRangeSlider } from "@redotech/redo-web/arbiter-components/range-slider/redo-range-slider";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { aiToneSliderConfig, type AiToneSliderKey } from "./tone-slider-config";

export interface ToneAndVoiceSlidersProps {
  settings: AiToneAndVoiceSettings;
  onChange: (settings: AiToneAndVoiceSettings) => void;
  disabled?: boolean;
}

function withToneRange(
  settings: AiToneAndVoiceSettings,
  key: AiToneSliderKey,
  value: [number, number],
): AiToneAndVoiceSettings {
  return { ...settings, [key]: { min: value[0], max: value[1] } };
}

/** Shared tone-of-voice range sliders (Commerce Agent intake + Recover onboarding). */
export const ToneAndVoiceSliders = memo(function ToneAndVoiceSliders({
  settings,
  onChange,
  disabled = false,
}: ToneAndVoiceSlidersProps) {
  return (
    <Flex dir="column" gap="2xl">
      {aiToneSliderConfig.map((slider) => (
        <Flex dir="column" gap="sm" key={slider.key}>
          <Text fontSize="sm" fontWeight="medium">
            {slider.label}
          </Text>
          <RedoRangeSlider
            disabled={disabled}
            leftLabel={slider.leftLabel}
            max={5}
            onChange={(value) =>
              onChange(withToneRange(settings, slider.key, value))
            }
            rightLabel={slider.rightLabel}
            value={[settings[slider.key].min, settings[slider.key].max]}
          />
        </Flex>
      ))}
    </Flex>
  );
});
